import UserActionTypes from './types';

export const setState = state => ({
  type: UserActionTypes.SET_STATE,
  payload: state,
});

export const loadCurrentAccountStart = (redirect = false) => ({
  type: UserActionTypes.LOAD_CURRENT_ACCOUNT,
  payload: redirect,
});

export const login = values => ({
  type: UserActionTypes.LOGIN,
  payload: values,
});

export const logout = () => ({
  type: UserActionTypes.LOGOUT,
});

export const deleteUserFacebookData = code => ({
  type: UserActionTypes.DELETE_USER_FACEBOOK_DATA,
  payload: code,
});

export const sendEmailConfirmationForDeletion = email => ({
  type: UserActionTypes.SEND_EMAIL_CONFIRMATION_FOR_DELETION,
  payload: email,
});

export const grantAdminRole = userId => ({
  type: UserActionTypes.GRANT_ADMIN_ROLE,
  payload: userId,
});

export const revokeAdminRole = userId => ({
  type: UserActionTypes.REVOKE_ADMIN_ROLE,
  payload: userId,
});
